import { requireTranslations } from '../../../common/translation';

export default requireTranslations((locale: string) => require(`./image-carousel.${locale}.json`));
